var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrow = function SvgArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 142,
    height: 84,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#FAC532",
    strokeLinecap: "round",
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.532 58.762c38.328-16.989 85.414-24.33 127.365-16.213M105.798 57.886c9.975-9.955 21.579-15.723 31.215-13.858M113.221 19.472c5.541 12.958 14.156 22.638 23.792 24.502"
  }))));
};
export default SvgArrow;